import { useState } from "react";
import { OncologySubmissionApiResponse } from "../../../api/bigQuery/oncologySubmissionOrders";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";

export interface OncologySubmissionTableState {
  data: OncologySubmissionApiResponse | undefined;
  loading: boolean;
  error: string | null;
  showInlineLoader: boolean;
}

export interface UseOncologySubmissionTableDataReturn {
  oncologySubmissionState: OncologySubmissionTableState;
  setOncologySubmissionState: React.Dispatch<
    React.SetStateAction<OncologySubmissionTableState>
  >;
  tableData: PharmaStpFileModel[];
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>;
}

export const useOncologySubmissionTableData =
  (): UseOncologySubmissionTableDataReturn => {
    const [tableData, setTableData] = useState<PharmaStpFileModel[]>([]);
    const [oncologySubmissionState, setOncologySubmissionState] =
      useState<OncologySubmissionTableState>({
        data: undefined,
        loading: false,
        error: null,
        showInlineLoader: false,
      });

    return {
      oncologySubmissionState,
      setOncologySubmissionState,
      tableData,
      setTableData,
    };
  };
